// Guida alle taglie: dal letto scelto e dall'altezza del materasso alle
// misure e ai prezzi in vendita. I dati vengono dai blocchi della sezione
// (data-* sui radio della larghezza): nessuna misura o prezzo scritto a mano
// qui. La mappa sotto resta solo come riserva per il test unitario, che gira
// senza DOM, e deve restare allineata al catalogo dei blocchi "letto" di
// sections/looniva-size-finder.liquid. Il markup prodotto da render() rispecchia,
// classe per classe, snippets/looniva-size-result.liquid: e' lo stesso
// pannello, reso la prima volta dal server (scelta di default, mai vuoto) e
// poi da qui a ogni cambio.
(() => {
  const FALLBACK_BEDS = {
    '90':  { name: 'Singolo', fitted: '90x200', fittedPrice: 49, flat: '160x290', flatPrice: 59, duvet: '155x200', duvetPrice: 79, setFalce: 79, setMezzaluna: 129, setPlenilunio: 199, collection: '/collections/lenzuola-singole', notInCatalog: false },
    '120': { name: 'Una piazza e mezza', fitted: '120x200', fittedPrice: 59, flat: '190x290', flatPrice: 69, duvet: '200x200', duvetPrice: 89, setFalce: 89, setMezzaluna: 149, setPlenilunio: 219, collection: '/collections/lenzuola-una-piazza-e-mezza', notInCatalog: false },
    '140': { name: 'Alla francese', fitted: '', fittedPrice: null, flat: '190x290', flatPrice: 69, duvet: '200x200', duvetPrice: 89, setFalce: null, setMezzaluna: null, setPlenilunio: null, collection: '/collections/lenzuolo-sopra', notInCatalog: true },
    '160': { name: 'Matrimoniale', fitted: '160x200', fittedPrice: 69, flat: '260x290', flatPrice: 79, duvet: '255x200', duvetPrice: 99, setFalce: 99, setMezzaluna: 169, setPlenilunio: 249, collection: '/collections/lenzuola-matrimoniali', notInCatalog: false },
    '180': { name: 'King size', fitted: '180x200', fittedPrice: 79, flat: '260x290', flatPrice: 79, duvet: '260x240', duvetPrice: 109, setFalce: 109, setMezzaluna: 179, setPlenilunio: 269, collection: '/collections/lenzuola-king-size', notInCatalog: false },
  };
  const FALLBACK_PILLOW = { size: '50x75', price: 39 };

  const bedsFromDOM = () => {
    const beds = {};
    document.querySelectorAll('input[name="lv-width"]').forEach((input) => {
      const d = input.dataset;
      if (!d.name) return;
      beds[input.value] = {
        name: d.name,
        fitted: d.fitted || '',
        fittedPrice: d.fittedPrice ? Number(d.fittedPrice) : null,
        flat: d.flat,
        flatPrice: Number(d.flatPrice),
        duvet: d.duvet,
        duvetPrice: Number(d.duvetPrice),
        setFalce: d.setFalcePrice ? Number(d.setFalcePrice) : null,
        setMezzaluna: d.setMezzalunaPrice ? Number(d.setMezzalunaPrice) : null,
        setPlenilunio: d.setPlenilunioPrice ? Number(d.setPlenilunioPrice) : null,
        collection: d.collection,
        notInCatalog: d.notInCatalog === 'true',
      };
    });
    return beds;
  };

  window.lvSizeFor = (width, height) => {
    const beds = bedsFromDOM();
    const b = (Object.keys(beds).length ? beds : FALLBACK_BEDS)[width];
    if (!b) return { ok: false };
    const pocket = b.notInCatalog ? 'na' : (height === 'oltre-30' ? 'warn' : 'ok');
    return { ok: true, ...b, pillow: FALLBACK_PILLOW.size, pillowPrice: FALLBACK_PILLOW.price, pocket };
  };

  document.querySelectorAll('[data-lv-size-finder]').forEach((form) => {
    const out = form.querySelector('[data-lv-size-result]');
    const render = () => {
      const w = form.querySelector('input[name="lv-width"]:checked')?.value;
      const h = form.querySelector('input[name="lv-height"]:checked')?.value;
      if (!w || !h) return;
      const r = window.lvSizeFor(w, h);
      const t = form.dataset;
      if (!r.ok) {
        out.innerHTML = `<p>${t.none} <a class="lv-link lv-link--small" href="${t.contactUrl || '/pages/contact'}">${t.contact}</a></p>`;
        return;
      }
      const fittedRow = r.notInCatalog
        ? `<li><span>${t.fitted}</span><span class="lv-sf__list-val"><b class="lv-sf__na">${t.notInCatalog}</b></span></li>`
        : `<li><span>${t.fitted}</span><span class="lv-sf__list-val"><b>${r.fitted}</b><em>${r.fittedPrice}&nbsp;€</em></span></li>`;
      const setsLine = r.notInCatalog
        ? ''
        : `<p class="lv-sf__sets lv-mat">${t.setsTitle}: ${t.setFalce} ${r.setFalce}&nbsp;€<span class="lv-sep">|</span>${t.setMezzaluna} ${r.setMezzaluna}&nbsp;€<span class="lv-sep">|</span>${t.setPlenilunio} ${r.setPlenilunio}&nbsp;€</p>`;
      const pocketText = r.pocket === 'na' ? t.notInCatalogNote : (r.pocket === 'warn' ? t.pocketWarn : t.pocketOk);
      out.innerHTML = `<div class="lv-sf__panel">
        <p class="lv-sf__panel-bed">${r.name}</p>
        <ul class="lv-sf__list">
          ${fittedRow}
          <li><span>${t.flat}</span><span class="lv-sf__list-val"><b>${r.flat}</b><em>${r.flatPrice}&nbsp;€</em></span></li>
          <li><span>${t.duvet}</span><span class="lv-sf__list-val"><b>${r.duvet}</b><em>${r.duvetPrice}&nbsp;€</em></span></li>
          <li><span>${t.pillow}</span><span class="lv-sf__list-val"><b>${r.pillow}</b><em>${r.pillowPrice}&nbsp;€ ${t.pillowPair}</em></span></li>
        </ul>
        ${setsLine}
        <p class="lv-sf__pocket">${pocketText}</p>
        <a class="lv-btn lv-btn--solid" href="${r.collection}">${t.shop}</a>
      </div>`;
    };
    form.addEventListener('change', render);
  });
})();
